import CRUDService from './CRUDService';
import {ResourceCategory} from './ResourceCategoriesService';

export interface ResourceSection {
  id?: number;
  name: string;
  description: string;
  screenshot: string;
  userTypes: string[];
  resourceCategories: ResourceCategory[];
}

export default new CRUDService<ResourceSection>({baseUrl: '/v1/resource-sections', useJWT: true});
